const s = ["xs", "sm", "base", "lg", "xl", "2xl", "3xl", "4xl", "5xl"], l = ["default", "primary", "success", "warning", "error"], t = ["lighter", "light", "main"], o = ["light", "regular", "medium", "bold"], r = "base", a = "default", e = "main", n = "regular";
export {
  a as DEFAULT_COLOR,
  e as DEFAULT_COLOR_SHADE,
  r as DEFAULT_VARIANT,
  n as DEFAULT_WEIGHT,
  t as colorShades,
  l as colors,
  s as variants,
  o as weights
};
